import {Navigate} from 'react-router-dom';
import {LOGIN, PRIVATE} from 'config/router/paths';
import {useAuthContext} from 'contexts/authContext';

export default function PublicRedirector() {
  const {isAuthenticated} = useAuthContext();
  if (isAuthenticated) {
    return <Navigate to={PRIVATE} />;
  }else{
    return <Navigate to={LOGIN} />;
  }
}
